import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/leaderboard/page.tsx")